import { baseBUCGet } from '../base/baseBUC';

const str = '';
const int = '';

export const conceptModelGet = ({
    buildingId = '',
    userId = '',
}) => {
    return {
        description: str,
        type: int,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};